var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup53(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.625,
    height: 62.534,
    viewBox: "0 0 86.625 62.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 86.625,
    height: 62.535,
    fill: "#7691d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0 0)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M18.379,40.459a65.688,65.688,0,0,1-6.518,19.428,1.774,1.774,0,0,0,2.417,2.4C32.4,51.725,40.351,36.318,41.338,23.964,42.192,13.307,34.922,2.327,23.9.329a20.273,20.273,0,1,0-5.522,40.13",
    transform: "translate(0 -0.001)",
    fill: "#7691d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M39.407,40.459a65.688,65.688,0,0,1-6.518,19.428,1.774,1.774,0,0,0,2.417,2.4c18.125-10.567,26.073-25.974,27.06-38.328C63.22,13.307,55.95,2.327,44.929.329a20.273,20.273,0,1,0-5.522,40.13",
    transform: "translate(24.19 -0.001)",
    fill: "#7691d6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup53);
export default __webpack_public_path__ + "static/media/Group53.b4d13d6c7bd1b6aca6115dff63a916fb.svg";
export { ForwardRef as ReactComponent };